import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';

import ProjectDirectoryQuery, {
	ProjectDirectoryQuery as ProjectDirectoryQueryType,
} from '../components/__generated__/ProjectDirectoryQuery.graphql';

export const projectDirectoryResource = createRelayResource<ProjectDirectoryQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		return {
			query: ProjectDirectoryQuery,
			variables: {
				aaid: context.user?.accountId,
				workspaceId: context.workspace?.globalId,
				workspaceUuid: context.workspace?.UUID ?? '',
			},
		};
	},
});
